import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import { GroupMember } from "../../lib/types";

interface RemoveMemberConfirmProps {
  open: boolean;
  member?: GroupMember | null;
  onClose: () => void;
  onConfirm: (member: GroupMember) => void;
}

const RemoveMemberConfirm: React.FC<RemoveMemberConfirmProps> = ({
  open,
  member,
  onClose,
  onConfirm,
}) => {
  if (!member) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Remove member</DialogTitle>
      <DialogContent>
        <Typography color="text.secondary">
          Remove {member.displayName || member.email || member.userId} from this
          group?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Tooltip title="Cancel">
          <IconButton
            onClick={() => {
              console.log("Canceling remove member");
              onClose();
            }}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Remove member">
          <IconButton
            color="error"
            onClick={() => {
              console.log("Removing member", { memberId: member.userId });
              onConfirm(member);
            }}
          >
            <PersonRemoveIcon />
          </IconButton>
        </Tooltip>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveMemberConfirm;
